import { adminUsersAPI } from 'api/admin-users';
import { FindAllAdminUserDto } from 'dto/admin-users';
import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { QUERY_KEY } from 'utils/enums';

type PropsType = {
  filters: FindAllAdminUserDto;
};

export function useFindAllAdminUser(props: PropsType) {
  const query = useQuery({
    queryKey: QUERY_KEY.FIND_ALL_ADMIN_USER,
    queryFn: () => adminUsersAPI.findAll(props.filters),
  });

  useEffect(() => {
    query.refetch();
  }, [props.filters]);

  return {
    query: query,
    count: query.data?.count ?? 0,
    rows: query.data?.rows ?? [],
    loading: query.isLoading || query.isFetching || query.isRefetching,
  };
}
